import { render, staticRenderFns } from "./AddTest.vue?vue&type=template&id=1724f3b3&scoped=true&"
import script from "./AddTest.vue?vue&type=script&lang=js&"
export * from "./AddTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724f3b3",
  null
  
)

export default component.exports